import { render } from "./Radio.vue?vue&type=template&id=0d1df9c6"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
script.render = render

export default script